module.exports = __webpack_public_path__ + "img/k2.b10d5847.jpg";